import React from 'react';
import moment from 'moment';

export default function DividendGrid({ div_data, hide_symbol_column, onPositonSelected }) {

    return (
        <table className="table table is-narrow is-fullwidth table is-hoverable">
            <thead>
                <th>Date</th>
                {(!hide_symbol_column) && <th>Symbol</th>}
                <th><span class="is-pulled-right">Quantity</span></th>
                {/* <th><span class="is-pulled-right">Dividend Yield</span></th> */}
                <th><span class="is-pulled-right">Divided Amount</span></th>
            </thead>
            <tfoot>
            <tr>
                <th></th>
                {(!hide_symbol_column) && <th>Symbol</th>}
                <th></th>
                {/* <th></th> */}
                <th><span class="is-pulled-right">{div_data.reduce((sum,x)=> sum+ parseFloat(x.amount),0).toFixed(2)}</span></th>
                </tr>
            </tfoot>
            <tbody>
                {div_data.map(function (div_item, i) {

                    return <tr>
                        <td>{moment(div_item.payable_date).format("LL")}</td>
                        {(!hide_symbol_column) &&<td>{div_item.symbol}</td>}
                        <td><span class="is-pulled-right">{div_item.position}</span></td>
                        {/* <td><span class="is-pulled-right">2%</span></td> */}
                        <td><span class="is-pulled-right">${ parseFloat( div_item.amount).toFixed(2)}</span></td>
                    </tr>
                })}
            </tbody>

        </table>
    );
}


// WEBPACK FOOTER //
// ./src/components/dividend-grid.js